import React from "react";
import { Link } from "react-router-dom";

function Footer() {
  var today = new Date();

  return (
    <footer className="modern-footer">
      <div className="container">
        <div className="row footer-content">
          <div className="col-lg-4 footer-section">
            <h5>ERA SALON</h5>
            <p>Your Beauty is our Business</p>
            <p>Premier salon services in Citrus Heights, CA</p>
          </div>
          <div className="col-lg-4 footer-section">
            <h5>Quick Links</h5>
            <ul className="footer-links">
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/team">Our Team</Link></li>
              <li><Link to="/gallery">Gallery</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </div>
          <div className="col-lg-4 footer-section">
            <h5>Contact Info</h5>
            <p>
              <i className="fas fa-map-marker-alt"></i> 7885 Lichen Dr, Citrus Heights, CA 95621
            </p>
            <p>
              <i className="fas fa-phone"></i> <a href="tel:9167221888">(916) 722-1888</a>
            </p>
            <p>
              <i className="fas fa-clock"></i> Mon-Fri: 9 AM - 7 PM | Sat-Sun: 10 AM - 6 PM
            </p>
            <div className="footer-social">
              <a
                href="https://www.facebook.com/Era-salon-305929286474054"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Facebook"
              >
                <i className="fab fa-facebook"></i>
              </a>
              <a
                href="https://www.google.com/search?sxsrf=ALeKk00mS7SVFP8jWvuxNcrEYyMjfa7DmQ%3A1597278395648&ei=u4g0X9KFJ4H49AP4jongCA&q=era+salon+sac&oq=era+salon+sac&gs_lcp=CgZwc3ktYWIQAzIICAAQsAMQzQIyCAgAELADEM0CMggIABCwAxDNAlAAWABg9MwBaABwAHgAgAFniAFnkgEDMC4xmAEAqgEHZ3dzLXdpesABAQ&sclient=psy-ab&ved=0ahUKEwiSz4Tb9ZbrAhUBPH0KHXhHAowQ4dUDCAw&uact=5"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Google"
              >
                <i className="fab fa-google"></i>
              </a>
              <a
                href="https://www.yelp.com/biz/era-salon-citrus-heights-4"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Yelp"
              >
                <i className="fab fa-yelp"></i>
              </a>
            </div>
          </div>
        </div>
        <div className="footer-bottom">
          <p>
            Copyright &copy; {today.getFullYear()} ERA SALON SAC | All Rights Reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
